<div class="modal-header">
  <h5 class="modal-title">Update PD Awards</h5>
  <button type="button" class="btn-close" (click)="dismiss()"></button>
</div>
<div class="modal-body">
  <p class="text-muted mb-3">
    Update <strong>{{ selectionCount }}</strong> selected Professional Development award{{
      selectionCount !== 1 ? 's' : ''
    }}.
  </p>

  <form #awardForm="ngForm">
    <div class="mb-3">
      <label class="form-label fw-semibold" for="description">Description</label>
      <input
        type="text"
        #description="ngModel"
        class="form-control"
        placeholder="e.g. Online Teaching Course"
        [(ngModel)]="updateProfessionalDevelopmentRecordCommand.description"
        name="description"
      />
    </div>
    <div validationErrors [for]="description.control" [errorEmitter]="errorEmitter" class="mb-3"></div>

    <div class="mb-3">
      <label class="form-label fw-semibold" for="hours">Hours</label>
      <input
        type="text"
        #hours="ngModel"
        class="form-control"
        placeholder="e.g. 6"
        [(ngModel)]="updateProfessionalDevelopmentRecordCommand.hours"
        name="hours"
      />
    </div>
    <div validationErrors [for]="hours.control" [errorEmitter]="errorEmitter" class="mb-3"></div>

    <div class="mb-3">
      <label class="form-label fw-semibold">Completion Date</label>
      <cert-date-input
        name="completionDate"
        [(model)]="updateProfessionalDevelopmentRecordCommand.completionDate"
        [propertyName]="'completionDate'"
      />
    </div>
    <div formLevelValidationErrors [for]="awardForm" [errorEmitter]="errorEmitter" class="mb-3"></div>

    <div class="mb-3">
      <label for="professionalDevelopmentTypeCodeId" class="form-label">Professional Development Type</label>
      <ng-select
        id="professionalDevelopmentTypeCodeId"
        name="professionalDevelopmentTypeCodeId"
        [closeOnSelect]="true"
        [multiple]="false"
        #professionalDevelopmentTypeCodeId="ngModel"
        [(ngModel)]="updateProfessionalDevelopmentRecordCommand.professionalDevelopmentTypeCodeId"
        placeholder="Select a type..."
      >
        @for (option of professionalDevelopmentTypeOptions; track option.id) {
          <ng-option [value]="option.id">{{ option.description }}</ng-option>
        }
      </ng-select>
      <div
        validationErrors
        [for]="professionalDevelopmentTypeCodeId.control"
        [errorEmitter]="errorEmitter"
        class="mb-3"
      ></div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="dismiss()" [disabled]="submitting()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="submitting()">
    @if (submitting()) {
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    }
    {{ submitting() ? 'Updating...' : 'Update' }}
  </button>
</div>
